import { Check } from "lucide-react";

// Customer-facing flow: pending → paid → packed → shipped → delivered
const FLOW = [
  { key: "pending", label: "Placed" },
  { key: "paid", label: "Paid" },
  { key: "packed", label: "Packed" },
  { key: "shipped", label: "Shipped" },
  { key: "delivered", label: "Delivered" },
];

export default function OrderTimeline({ status = "pending", compact = false }) {
  // Cancelled / payment_failed get a single error pill
  if (status === "cancelled" || status === "payment_failed") {
    return (
      <div
        data-testid="order-timeline"
        className={`inline-flex items-center gap-2 doodle-pill bg-[#FFE4E4] text-[#7A1F2B] ${compact ? "text-xs" : "text-sm"}`}
      >
        {status === "cancelled" ? "Cancelled" : "Payment Failed"}
      </div>
    );
  }

  const idx = Math.max(0, FLOW.findIndex((s) => s.key === status));
  const currentIdx = idx === -1 ? 0 : idx;

  return (
    <div data-testid="order-timeline" className="w-full">
      <div className="flex items-center w-full">
        {FLOW.map((step, i) => {
          const done = i < currentIdx;
          const active = i === currentIdx;
          const dotSize = compact ? "w-6 h-6" : "w-8 h-8";
          const labelSize = compact ? "text-[10px]" : "text-xs";
          return (
            <div key={step.key} className="flex-1 flex items-center" data-testid={`timeline-step-${step.key}`}>
              <div className="flex flex-col items-center flex-shrink-0">
                <div
                  className={`${dotSize} rounded-full border-2 border-[#2D2424] flex items-center justify-center transition-colors ${
                    done ? "bg-[#C8E6C9]" : active ? "bg-[#FFD93D]" : "bg-white"
                  }`}
                  style={{ boxShadow: active ? "2px 2px 0 #2D2424" : "none" }}
                >
                  {done ? (
                    <Check className={compact ? "w-3 h-3" : "w-4 h-4"} strokeWidth={3}/>
                  ) : (
                    <span className={`font-doodle ${compact ? "text-xs" : "text-sm"} text-[#2D2424]`}>{i + 1}</span>
                  )}
                </div>
                <span className={`mt-1 font-hand ${labelSize} ${active ? "text-[#7A1F2B] font-semibold" : "text-[#5C5555]"} whitespace-nowrap`}>
                  {step.label}
                </span>
              </div>
              {i < FLOW.length - 1 && (
                <div className={`flex-1 h-[2px] mx-1 -mt-4 ${i < currentIdx ? "bg-[#7A1F2B]" : "bg-[#2D2424]/15"}`}/>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
